module.exports = __webpack_public_path__ + "img/1920_banner_4.08a46e4d.jpg";